import { ComponentProps } from "react";

import AppContextValueProvider from "../../../App/Compositions/AppContextValueProvider";
import ObservedSchedulingLoader from "../Components/ObservedSchedulingLoader";
import ISchedulingLoaderProps from "../Types/ISchedulingLoaderProps";

const AppContextSchedulingLoader = AppContextValueProvider<
  ISchedulingLoaderProps,
  ComponentProps<typeof ObservedSchedulingLoader>
>({
  Component: ObservedSchedulingLoader,
  map: ({ bookingController, customerCState, reservation, router }) => ({
    bookingController,
    customerFirstName: customerCState.displayFirstName,
    reservation,
    router
  })
});

export default AppContextSchedulingLoader;
